export const BannerMessageConfig = {
  api: {
    // get
    index: () => `/dashboard/organization-banners/`,
    // post
    create: () => `/dashboard/organization-banners/`,
    // patch
    update: (bannerId) => `/dashboard/organization-banners/${bannerId}/`,
    // patch
    delete: (bannerId) => `/dashboard/organization-banners/${bannerId}/`,
  },
  events: {
    name: 'banner-message',
    // refresh-index-data
    refresh: `rid-banner-message`,
    // slideover-right
    sorId: 'banner-message',
    sorOpen: 'sor-open-banner-message',
    sorClose: 'sor-close-banner-message',
    sorToggle: 'sor-toggle-banner-message',
    // editing-data
    editingData: 'edit-banner-message-data',
    // viewing-data
    viewingData: 'view-banner-message-data',
  },
}
